import { AppColors } from "@/assets/colors";
import { AppSize, IAppStore, ListingStatus, pxToRem } from "@/util";
// import { Typography } from "@mui/material";
import Image from "next/image";
import React from "react";
import { makeStyles } from "tss-react/mui";
import BasicTabs from "./tab";
import {
  Box,
  Drawer,
  // Button,
  // Divider,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import SearchIcon from "@mui/icons-material/Search";
import PortfolioFilter from "../filter/portfolio";
import { useDispatch, useSelector } from "react-redux";
import {
  setLocation,
  setPriceRange,
  setPropertyName,
  setPropertyType,
  setSearch,
  setSort,
  setStatus,
} from "@/store/propertyfilter";
import { useSearchParams } from "next/navigation";
import { InvestmentStatus } from "@/util/types/investment";
type props = {
  pageName: string;
};
export default function Explore({ pageName }: Partial<props>) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(860));
  const { classes } = styles();
  const [openFilt, setOpenFilt] = React.useState<boolean>(false);
  const searchParams = useSearchParams();
  const currentPage = searchParams.get("type");
  const appStatus =
    currentPage === "INVESTMENTS" ? InvestmentStatus : ListingStatus;
  const propFilter = useSelector((state: IAppStore) => state.propertyFilter);
  const { location, propertyType, sort, status, priceRange, propertyName } =
    propFilter;
  const dispatch = useDispatch();
  const handleMobileSearch = () => {
    dispatch(setSearch(true));
    setOpenFilt(false);
  };
  return (
    <Box className={classes.container}>
      <Box className={` ${classes.sub} `}>
        <Box className={` ${classes.left} `}>
          <Typography className={classes.headTxt}>
            Explore Our Property{" "}
            {pageName === "INVESTMENTS" ? "Investment Offers" : "Listings"}
          </Typography>
          <Typography className={classes.detTxt}>
            Discover our collection of premium properties, from completed luxury
            homes to upcoming investment opportunities
          </Typography>
        </Box>
        <Box className={` ${classes.right}`}>
          <Image
            src="/images/explore/explore.svg"
            objectFit="cover"
            fill
            alt="Property listings"
          />
        </Box>
      </Box>
      <Drawer open={isMobile && openFilt} anchor="bottom">
        <PortfolioFilter
          handleSearch={() => handleMobileSearch()}
          status={status}
          statusData={Object.keys(appStatus).map((key) => ({
            label: key,
            value: key,
          }))}
          propertyType={propertyType}
          setPropertyType={(e) => dispatch(setPropertyType(e))}
          setStatus={(e) => dispatch(setStatus(e))}
          handleClose={() => setOpenFilt(false)}
          sort={sort}
          setSort={(e) => dispatch(setSort(e))}
          location={location}
          setLocation={(e) => dispatch(setLocation(e))}
          priceRange={priceRange}
          setPriceRange={(e) => dispatch(setPriceRange(e))}
          isPriceRange={pageName !== "INVESTMENTS"}
        />
      </Drawer>
      <Box className={`${classes.nav} `}>
        <BasicTabs />
      </Box>

      {/* search on mobile */}
      <Box className={`${classes.mobileNav}`}>
        <Paper className={`${classes.mobile}`} elevation={2}>
          <TextField
            // className={classes.input}
            fullWidth
            variant="outlined"
            placeholder="Search for Property"
            value={propertyName}
            onChange={(e) => dispatch(setPropertyName(e.target.value))}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    aria-label="search"
                    onClick={() => dispatch(setSearch(true))}
                  >
                    <SearchIcon
                      fontSize="large"
                      // className={classes.searchIcon}
                    />
                  </IconButton>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="start">
                  <IconButton
                    aria-label="search"
                    onClick={() => setOpenFilt(true)}
                  >
                    <TuneIcon fontSize="large" />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Paper>
      </Box>
    </Box>
  );
}

const styles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    flex: 1,
    flexDirection: "column",
    minHeight: pxToRem(700),
    position: "relative",
    justifyContent: "flex-end",
    backgroundColor: AppColors.neutral["55"],
    overflow: "hidden",
  },
  sub: {
    position: "absolute",
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    height: "100%",
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      gridTemplateColumns: "1fr",
    },
  },
  right: {
    position: "relative",
    [theme.breakpoints.down("sm")]: {
      position: "absolute",
      inset: 0,
      zIndex: 0,
      "& img": {
        objectFit: "cover",
        zIndex: 0,
        filter: "brightness(0.5)",
      },
    },
  },
  left: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: pxToRem(AppSize.padding),
    paddingRight: theme.spacing(3),
    gap: theme.spacing(3),
    zIndex: 1,
    [theme.breakpoints.down("sm")]: {
      padding: `${pxToRem(0)} ${pxToRem(15)}`,
    },
  },
  nav: {
    height: pxToRem(204),
    display: "flex",
    flexDirection: "row",
    position: "relative",
    zIndex: 10,
    marginBottom: pxToRem(-10),
    paddingLeft: pxToRem(AppSize.padding),

    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  headTxt: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: "clamp(2rem, 5vw, 3.75rem)",
    width: "90%",
    lineHeight: "120%",
    [theme.breakpoints.down("sm")]: {
      color: AppColors.neutral["110"],
      width: "93%",
    },
  },
  detTxt: {
    color: AppColors.text.second,
    fontWeight: 400,
    fontSize: "clamp(1rem, 2.5vw, 1.25rem)",
    marginBottom: pxToRem(60),
    width: "80%",
    lineHeight: "120%",
    [theme.breakpoints.down("sm")]: {
      color: AppColors.neutral["110"],
      fontWeight: 300,
      width: "100%",
      fontSize: pxToRem(20),
    },
  },
  mobileNav: {
    display: "none",
    [theme.breakpoints.down("md")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(AppSize.padding)}`,
    },
    [theme.breakpoints.down(600)]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(20)}`,
    },
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: `0px ${pxToRem(20)}`,
      marginBottom: pxToRem(20),
    },
  },
  mobile: {
    width: "100%",
    zIndex: 10,
  },
}));
